import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "flex-fill-v-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("path", { d: "M8.5 3v11" }),
        React.createElement("path", { fill: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m10.25 4.5-1.75-2-1.75 2zm0 8-1.75 2-1.75-2z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
